import Footer from '../../sections/footer/Footer'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'

import './style.scss'
import HeaderPages from '../../sections/header/HeaderPages'
// import { PAGE_URLS } from '../../constants/hrefLinks'

function TermsAndConditions() {
	
	return (
		<>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<HeaderPages />
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
				<h1>H & B GLOBAL Ltd</h1>
<h2>Terms of Use Agreement</h2>
<p><strong>Last Updated Date:</strong> [22/7/25]</p>

<p>Welcome to SkiVio! PLEASE READ CAREFULLY THIS TERMS OF USE AGREEMENT (“<strong>TERMS</strong>”). THESE TERMS FORM A LEGAL CONTRACT BETWEEN YOU AND H & B GLOBAL Ltd. (“<strong>SKIVIO</strong>,” “<strong>WE</strong>,” “<strong>US</strong>” OR “<strong>OUR</strong>”) governing your use, and SkiVio’s provision to you of <a href="https://skivio.co/">https://skivio.co/</a> or any other websites, tools, and social media pages with a link to these Terms, the SkiVio marketplace platform, or any content, information, services, features, or resources available or enabled thereon (collectively, the “<strong>Platform</strong>”). These Terms govern your access to and use of the Platform and Instructor Services (as defined below, and together with the Platform, the “<strong>Services</strong>”). You may register on the Platform as either a Skier / Snowboard skier (referred hereafter to as “<strong>skiers</strong>”) or as an Instructor. These Terms apply to Skiers and Instructors. For more information on how we collect, use, and store personal information, please review our Privacy Policy.</p>

<p>Your use of the Services may be subject to any additional terms, conditions, and policies that we separately post on the Services and any agreements that you have separately executed with SkiVio (“<strong>Supplemental Terms</strong>”) which are incorporated by reference into these Terms, (together, the “<strong>Agreement</strong>”). Without limiting the generality of the foregoing, to the extent there is any conflict between these Terms and any Supplemental Terms, the Supplemental Terms will control with respect to the subject matter of such agreement.</p>

<p>BY CLICKING “I ACCEPT” OR BY OTHERWISE ACCESSING, USING OR INTERACTING WITH THE SERVICES, ACCESSING, USING OR INTERACTING WITH ANY CONTENT, INFORMATION, SERVICES, FEATURES OR RESOURCES AVAILABLE OR ENABLED VIA THE SERVICES, YOU HEREBY: -br-
(A) AGREE THAT YOU HAVE READ, UNDERSTAND, AND AGREE TO BE BOUND BY THIS AGREEMENT AND ANY FUTURE AMENDMENTS AND ADDITIONS TO THIS AGREEMENT AS PUBLISHED THROUGH THE SERVICES; -br-
(B) REPRESENT YOU ARE OF LEGAL AGE IN YOUR JURISDICTION OF RESIDENCE TO FORM A BINDING CONTRACT; AND -br-
(C) YOU ARE NOT A PERSON OR ENTITY BARRED FROM USING THE SERVICES UNDER THE LAWS OF THE UNITED STATES, YOUR PLACE OF RESIDENCE, OR ANY OTHER APPLICABLE JURISDICTION. EXCEPT AS OTHERWISE PROVIDED HEREIN, IF YOU DO NOT AGREE TO BE BOUND BY THIS AGREEMENT, YOU MAY NOT ACCESS OR USE THE SERVICES.</p>

<h2>ARBITRATION NOTICE</h2>
<p>SECTION 12 OF THESE TERMS CONTAINS AN ARBITRATION AGREEMENT THAT GOVERNS HOW TO RESOLVE DISPUTES BETWEEN YOU AND US. AMONG OTHER THINGS, IT PROVIDES, WITH LIMITED EXCEPTIONS, THAT ALL DISPUTES BETWEEN YOU AND US WILL BE RESOLVED BY BINDING AND FINAL ARBITRATION.</p>

<h2>GENERAL NOTICE</h2>
<p>SKIVIO DOES NOT PROVIDE INSTRUCTOR SERVICES OF ANY KIND. INSTRUCTORS (AS DEFINED BELOW) ARE NOT EMPLOYEES, PARTNERS, REPRESENTATIVES, AGENTS, JOINT VENTURERS, OR FRANCHISEES OF SKIVIO. YOU HEREBY ACKNOWLEDGE THAT SKIVIO DOES NOT SUPERVISE, DIRECT, CONTROL OR ACCEPT ANY RESPONSIBILITY FOR INSTRUCTOR SERVICES BUT MAY MONITOR AND FACILITATE INSTRUCTOR SERVICES ARRANGED THROUGH THE PLATFORM.</p>

<h2>INSTRUCTOR SERVICES</h2>
<p>SkiVio provides a service that:</p>
<ul>
<li>Allows individuals seeking instruction (each, a “<strong>Skier</strong>”) to search for and connect with instructors (each, an “<strong>Instructor</strong>,” and the services thereof, the “<strong>Instructor Services</strong>”).</li>
<li>Provides a platform where Skiers and Instructors can interact and share content regarding the activity in the Instructor’s area of expertise with respect to which the Skier is seeking instruction.</li>
</ul>
<p>All Instructor Services shall be delivered via the Platform and all communications between Instructor and Skier related to the Instructor Services must take place on the Platform. The Instructor Services will include the provision of feedback on and analysis of videos uploaded by Skiers and may also include support, skill development and acquisition, and other instruction. Instructors and Skiers shall be collectively referred to herein as “<strong>Platform Users</strong>.”</p>

<h2>Payment Terms</h2>
<h3>Instructor Rates</h3>
<p>Instructors are responsible for setting their own rate (the “<strong>Instructor Rate</strong>”), not to exceed any upper limit established by SkiVio for the Instructor’s level, which levels are set by reference to applicable qualification requirements. Upper limits, if any, will be specified on the Instructor dashboard.</p>

<h3>For Skiers</h3>
<p>Skiers agree to pay to SkiVio all fees associated with the Instructor Services purchased, at the applicable Instructor Rate presented at the time of purchase. All fees paid by Skiers are non-refundable. Platform Users are responsible for any applicable taxes relating to Instructor Fees.</p>

<h3>For Instructors</h3>
<p>Amounts to be retained by SkiVio and/or paid by SkiVio to Instructors shall be the then-current amounts indicated on the Instructor dashboard.</p>

<h3>Third-Party Payment Processor</h3>
<p>SkiVio may accept payments from Skiers via third-party vendors. SkiVio does not control and is not liable for third-party vendors’ operations or terms.</p>

<h3>Bookings; Sessions</h3>
<p>Once a booking is confirmed, Instructors are responsible for fulfillment within 24 hours, delivering the booked services solely via the Platform.</p>

<h2>Registration and Accounts</h2>
<h3>Your Account</h3>
<p>You are responsible for providing true and accurate information and for maintaining the confidentiality of your Account.</p>

<h3>Special Terms</h3>
<h4>Skiers</h4>
<p>Skiers must be at least 18 years old. SkiVio is not responsible for the quality or outcome of Instructor Services.</p>

<h4>Instructors</h4>
<p>Instructors must provide background and credentials for SkiVio’s approval. SkiVio may rank Instructors based on criteria at its discretion.</p>

<h2>Access to the Service</h2>
<h3>Access and Use</h3>
<p>SkiVio grants a limited right to access and use the Services for personal or instructional purposes.</p>

<h3>Certain Restrictions</h3>
<p>Users may not exploit, modify, reverse engineer, or reproduce the Services except as expressly permitted.</p>

<h3>Modification</h3>
<p>SkiVio reserves the right to modify or discontinue the Services at any time without liability.</p>

<h3>No Support or Maintenance; Necessary Equipment</h3>
<p>SkiVio has no obligation to provide support or maintenance. Users are responsible for their own equipment and fees.</p>

<h3>Ownership</h3>
<p>All intellectual property in the Services is owned by SkiVio or its suppliers.</p>

<h3>Social Networking Site</h3>
<p>Users may share content via social networks under their own privacy settings and terms.</p>

<h2>Platform User Content and Responsibilities</h2>
<h3>Platform User Content</h3>
<p>Users are solely responsible for their submitted content and warrant they have all necessary rights.</p>

<h3>Content Ownership &ndash; License to Your Content</h3>
<p>Users retain ownership but grant SkiVio a perpetual, irrevocable license to use and exploit their content.</p>

<h3>Enforcement</h3>
<p>SkiVio may remove content or terminate accounts for violations.</p>

<h3>Content Disclaimer</h3>
<p>All content is provided “as is” for informational purposes only.</p>

<h3>Feedback</h3>
<p>Users assign all rights in feedback to SkiVio, treating it as non-confidential.</p>

<h2>Acceptable Use Policy</h2>
<p>Users must not upload harmful, illegal, or infringing content, nor interfere with the Services.</p>

<h2>SkiVio Communications</h2>
<p>By providing contact information, users consent to receive communications via email, SMS, calls, and push notifications.</p>

<h2>Procedure for Making Claims of Copyright Infringement</h2>
<p>Details of the DMCA notice procedure are provided for copyright claims.</p>

<h2>Termination and Modification</h2>
<h3>Term &mdash; Termination</h3>
<p>Details on account termination by violation, by user request, and effects of termination.</p>

<h3>Modification of the Services</h3>
<p>SkiVio may modify or discontinue the Services without notice.</p>

<h2>Third-Party Links and Content; Other Users</h2>
<p>SkiVio is not responsible for third-party content or other users’ actions.</p>

<h2>Indemnification</h2>
<p>Users agree to indemnify SkiVio for any claims arising from their use of the Services.</p>

<h2>Disclaimer of Warranties</h2>
<p>The Services are provided “as is” without warranties of any kind.</p>

<h2>Limitation of Liability</h2>
<p>SkiVio’s liability is limited to the greater of amounts paid in the past 12 months or $100.</p>

<h2>Arbitration Agreement</h2>
<p>Section 12 provides for mandatory binding arbitration, class action waiver, and related procedures.</p>

<h2>General Provisions</h2>
<p>Additional terms including governing law (Delaware), modification of agreement, assignment, force majeure, and entire agreement.</p>

<h2>Contact Information</h2>
<p><strong>H & B GLOBAL Ltd</strong>-br-
REGISTERED ADDRESS: 6A Thornhill Road, London, England-br-
EMAIL: <a href="mailto:management@skivio.co">management@skivio.co</a></p>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default TermsAndConditions
